export enum CommunicationsResponseDialAsyncServiceRequestError {
  dialError = 'dialError',
}
